export enum NatureDocument {
    REGISTRE_COMMERCE = 'Numero de série',
    DE = 'IMEI/MAC',
}
